export const SidebarIdGlobalProjectsSettings = 'GLOBAL_PROJECTS_SETTINGS' as const;
